// AccionesCell.jsx
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import EditIcon from '@mui/icons-material/Edit';
import Swal from 'sweetalert2';
import axios from 'axios';
import ModalCobranza from '../ModalCobranza';
import ModalEnvioCobranza from '../ModalEnvioCobranza';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import ModalInfo from 'layouts/pages/finantial/invoice-list/components/ModalInfo';
import { AuthContext } from 'context/AuthContext';

function AccionesCell({ cobranza, getData, setIsLoading }) {
  const [showModal, setShowModal] = useState(false);
  const [showModalEnvio, setShowModalEnvio] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);

  const { hasRole } = useContext(AuthContext);
  const isClient = hasRole('client');
  const canEdit = hasRole('admin', 'user');
  const canEmail = hasRole('admin', 'user');
  const canDelete = hasRole('admin', 'user');

  // ✅ ID robusto (id -> id_cobranza -> numero)
  const docId = cobranza?.id ?? cobranza?.id_cobranza ?? cobranza?.numero;

  const handleDelete = async () => {
    try {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        setIsLoading(true);
        await axios.delete(`${process.env.REACT_APP_SERVER_URL}/api/finance/invoice/${docId}/`);
        Swal.fire({ title: '¡Eliminado!', text: 'El registro ha sido eliminado correctamente.', icon: 'success' });
      }
    } catch (error) {
      Swal.fire({ title: 'Error', text: 'Hubo un problema al eliminar el registro.', icon: 'error' });
    } finally {
      getData();
    }
  };

  const exportAsPDF = async () => {
    try {
      const token = localStorage.getItem('accessToken'); // o donde lo guardes
      const url = `${process.env.REACT_APP_SERVER_URL}/api/finance/pdf/${docId}/`;
      const res = await axios.get(url, {
        responseType: 'blob',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank'); // abre en otra pestaña
    } catch (error) {
      const msg =
        error?.response?.status === 401
          ? `Error 401 (no autorizado). ¿El token está vencido?`
          : `Error ${error?.response?.status || ''}`;
      Swal.fire({ title: 'Error', text: `Hubo un problema al generar el PDF. ${msg}`, icon: 'error' });
    }
  };

  const actions = [
    { Icon: DescriptionIcon, onClick: () => setShowModalInfo(true), color: 'warning' },
    { Icon: PictureAsPdfIcon, onClick: exportAsPDF, color: 'secondary' },
  ];

  if (!isClient) {
    if (canEdit) actions.push({ Icon: EditIcon, onClick: () => setShowModal(true), color: 'primary' });
    if (canEmail) actions.push({ Icon: EmailIcon, onClick: () => setShowModalEnvio(true), color: 'info' });
    if (canDelete) actions.push({ Icon: DeleteIcon, onClick: handleDelete, color: 'error' });
  }

  return (
    <>
      <DataTableDocumentActions actions={actions} />

      <ModalInfo show={showModalInfo} handleClose={() => setShowModalInfo(false)} documentId={docId} />

      <ModalCobranza
        show={showModal}
        handleClose={() => setShowModal(false)}
        getData={getData}
        documentToEdit={cobranza}
      />

      <ModalEnvioCobranza
        cobranza_id={docId}
        getData={getData}
        show={showModalEnvio}
        handleClose={() => setShowModalEnvio(false)}
      />
    </>
  );
}

AccionesCell.propTypes = {
  cobranza: PropTypes.object.isRequired,
  getData: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
};

export default AccionesCell;
